.displayFraction {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;

  /* Fraction part */
  .fractionPart {
    font-size: var(--font-size-xs);
  }
}
